<div
  class="editable"
  *ngIf="!editing"
  (click)="edit()"
  (focus)="edit()"
  tabindex="0"
  [ngClass]="{ readonly: readonly, 'mat-empty-cell-overlay': emptyCellOverlay }"
  [matTooltip]="showTip"
  [class.locked]="fieldDef.locked"
>
  <ng-container *ngIf="isNestedField && isIdField; else numberField">
    <linkable-related-field-cell [type]="fieldDef?.related_to_type" [value]="value"></linkable-related-field-cell>
  </ng-container>

  <ng-template #numberField>
    {{ value | formatNumber: precision:fieldDef }}
  </ng-template>
</div>
<input
  #inputEditorControl
  [(ngModel)]="value"
  type="text"
  *ngIf="editing"
  (blur)="onBlur($event)"
  (keyup.enter)="onBlur($event)"
  tabindex="0"
  [disabled]="isDisabled"
/>
